"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolsRagDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const types_1 = require("../../types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-rag-data">
  ${(0, fast_element_1.when)(x => x.ragData && x.ragData.fileList && x.ragData.fileList.length > 0, (0, fast_element_1.html) `
  <div class="files-container">
    <ul>
      ${(0, fast_element_1.repeat)(x => x.ragData.fileList, (0, fast_element_1.html) `
      <li>
        <div class="tool-entry">
          <div class="file-info">
            <div class="file-name">${file => file.name}</div>
            <div class="file-size">${(file, c) => c.parent.formatFileSize(file.size)}</div>
          </div>
          <div class="file-actions">
            <rws-tooltip text="${'rag.open_sources'.t()}" side="left">
              <button class="btn btn-primary open-sources-btn"
                @click="${(file, c) => c.parent.openFileSources(file.id)}">
                <i class="simple-icon-${(x, c) => c.parent.openedSourcesFileId === x.id ? 'close' : 'docs'} mr-1"></i>
                ${'rag.sources'.t()}
              </button>
            </rws-tooltip>

            <rws-tooltip text="${'rag.open_knowledge_preview'.t()}" side="left">
              <button class="btn btn-primary open-file-btn"
                @click="${(file, c) => c.parent.openFileInKnowledgeBase(file.id)}">
                <i class="simple-icon-magnifier mr-1"></i> ${'rag.openInKnowledgeBase'.t()}
              </button>
            </rws-tooltip>
          </div>
        </div>
        <div class="file-sources" ?hidden="${(x, c) => c.parent.openedSourcesFileId !== x.id}">
          <strong>${'rag.sources_used'.t()}:</strong>
          <div class="sources-list">
            ${(0, fast_element_1.repeat)(file => file.sources || [], (0, fast_element_1.html) `
              <p class="source-item">${source => source}</p>
            `)}
          </div>
        </div>
      </li>
      `)}
    </ul>
  </div>
  `)}

  ${(0, fast_element_1.when)(x => !x.ragData || !x.ragData.fileList || x.ragData.fileList.length === 0, (0, fast_element_1.html) `
  <div class="empty-state">
    <p>${'rag.noFilesIncluded'.t()}</p>
  </div>
  `)}
</div>
${(0, fast_element_1.when)(x => x.openedModal && x.selectedKnowledgeId, (0, fast_element_1.html) `
<rws-modal header="knowledge.preview" centerTop="false" :closeModal="${x => x.closeKnowledgeModal.bind(x)}">
  <div class="knowledge-form-modal-content">
    <div class="modal-body">
      <div class="container-fluid">
        <knowledge-preview :knowledgeId="${x => x.selectedKnowledgeId}" compact="true">
        </knowledge-preview>
      </div>
    </div>
  </div>
</rws-modal>
`)}`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-rag-data {
  border-radius: 12px;
}
.rws-tools-rag-data h3 {
  color: var(--success-color, #28a745);
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rws-tools-rag-data .files-container {
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  padding: 16px;
}
.rws-tools-rag-data .files-container ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
}
.rws-tools-rag-data .files-container ul li .tool-entry {
  background: var(--bg-tertiary, #ffffff);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.rws-tools-rag-data .files-container ul li .tool-entry:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color, #007acc);
}
.rws-tools-rag-data .files-container ul li .tool-entry:hover::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--primary-color, #007acc);
}
.rws-tools-rag-data .files-container ul li .tool-entry {
  position: relative;
  overflow: hidden;
  justify-items: space-between;
}
.rws-tools-rag-data .files-container ul li .tool-entry .file-info {
  flex: 1;
  min-width: 0;
}
.rws-tools-rag-data .files-container ul li .tool-entry .file-info .item-title, .rws-tools-rag-data .files-container ul li .tool-entry .file-info .file-name {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  margin-bottom: 2px;
  word-break: break-word;
}
.rws-tools-rag-data .files-container ul li .tool-entry .file-info .item-subtitle, .rws-tools-rag-data .files-container ul li .tool-entry .file-info .file-id {
  font-size: 0.8rem;
  color: var(--text-tertiary, #9ca3af);
  font-family: monospace;
}
.rws-tools-rag-data .files-container ul li .tool-entry .file-info .item-description {
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  line-height: 1.5;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border-color-light, #dee2e6);
}
.rws-tools-rag-data .files-container ul li .file-sources {
  width: 100%;
  margin-top: 10px;
  flex-basis: 100%;
  order: 1;
}
.rws-tools-rag-data .files-container ul li .file-sources .sources-list {
  max-height: 300px;
  overflow-y: auto;
  margin-top: 8px;
}
.rws-tools-rag-data .files-container ul li .file-sources .sources-list p {
  margin: 8px 0;
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  font-size: 0.875rem;
}
.rws-tools-rag-data .files-container ul li .file-sources .sources-list p:first-of-type {
  margin-top: 4px;
}
.rws-tools-rag-data .files-container ul li .file-sources .sources-list p:last-of-type {
  margin-bottom: 0;
}
.rws-tools-rag-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-rag-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-rag-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-rag-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
.rws-tools-rag-data .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: var(--text-secondary, #6c757d);
  gap: 12px;
}
.rws-tools-rag-data .loading-state .spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-color, #e1e5e9);
  border-top: 2px solid var(--primary-color, #007acc);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.rws-tools-rag-data .loading-state .loading-text {
  font-weight: 500;
}
[data-theme=dark] .rws-tools-rag-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-rag-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-rag-data .tool-list-item .item-title, [data-theme=dark] .rws-tools-rag-data .tool-list-item .files-container ul li .tool-entry .file-info .file-name, [data-theme=dark] .rws-tools-rag-data .files-container ul li .tool-entry .file-info .tool-list-item .file-name {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-rag-data .tool-list-item .item-subtitle, [data-theme=dark] .rws-tools-rag-data .tool-list-item .files-container ul li .tool-entry .file-info .file-id, [data-theme=dark] .rws-tools-rag-data .files-container ul li .tool-entry .file-info .tool-list-item .file-id {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-rag-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-rag-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-rag-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-rag-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-rag-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-rag-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-rag-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-rag-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-rag-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-rag-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-rag-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-rag-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-rag-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-rag-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-rag-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-rag-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-rag-data .tool-container {
    padding: 12px;
  }
  .rws-tools-rag-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-rag-data .tool-list-item .item-title, .rws-tools-rag-data .tool-list-item .files-container ul li .tool-entry .file-info .file-name, .rws-tools-rag-data .files-container ul li .tool-entry .file-info .tool-list-item .file-name {
    font-size: 0.9rem;
  }
  .rws-tools-rag-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-rag-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-rag-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-rag-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let ToolsRagDataComponent = class ToolsRagDataComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.openedModal = false;
        this.selectedKnowledgeId = null;
        this.openedSourcesFileId = null;
    }
    openFileInKnowledgeBase(fileId) {
        this.selectedKnowledgeId = fileId;
        this.openedModal = true;
    }
    openFileSources(fileId) {
        if (!this.openedSourcesFileId) {
            this.openedSourcesFileId = fileId;
        }
        else {
            this.openedSourcesFileId = null;
        }
    }
    closeKnowledgeModal() {
        this.openedModal = false;
        this.selectedKnowledgeId = null;
    }
    formatFileSize(sizeInBytes) {
        if (sizeInBytes < 1024) {
            return `${sizeInBytes} B`;
        }
        else if (sizeInBytes < 1048576) {
            return `${(sizeInBytes / 1024).toFixed(2)} KB`;
        }
        else if (sizeInBytes < 1073741824) {
            return `${(sizeInBytes / 1048576).toFixed(2)} MB`;
        }
        else {
            return `${(sizeInBytes / 1073741824).toFixed(2)} GB`;
        }
    }
};
exports.ToolsRagDataComponent = ToolsRagDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.RagData !== "undefined" && types_1.RagData) === "function" ? _a : Object)
], ToolsRagDataComponent.prototype, "ragData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ToolsRagDataComponent.prototype, "openedModal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ToolsRagDataComponent.prototype, "selectedKnowledgeId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], ToolsRagDataComponent.prototype, "openedSourcesFileId", void 0);
exports.ToolsRagDataComponent = ToolsRagDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-rag-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ToolsRagDataComponent);
ToolsRagDataComponent.defineComponent();
